import styled from "@emotion/styled";
import Link from "@mui/material/Link";
import theme from "shared/theme";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { text } from "shared/theme/mixins";

export const StyledDashboardLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  text-decoration: none;
  ${text(theme.typography.bodySMedium)};
  cursor: pointer;

  color: ${COLOR_PRIMARY_MAIN};

  &:hover {
    color: ${COLOR_PRIMARY_MAIN};
  }

  &:active {
    color: ${COLOR_PRIMARY_MAIN};
  }
`;
